import { ajax, nodeArray } from 'meteora';
import DuplicatingFields from '../classes/duplicating-fields.js';
import SimpleSelector from 'simple-selector';
document.addEventListener('DOMContentLoaded', function () {
  var quoteForm = document.getElementById('GetAQuoteForm_GetAQuoteForm');
  var locationSelect = quoteForm !== null ? quoteForm.querySelector('select.js-update-reps') : false;
  var repsSelect = quoteForm !== null ? quoteForm.querySelector('select.js-select-rep') : false;
  if (quoteForm) {
    var selectors = [];
    var selects = [];
    quoteForm.DuplicatingFields = new DuplicatingFields(quoteForm);
    quoteForm.addEventListener('duplicated', function () {
      selectors = quoteForm.DuplicatingFields.newElements('.formSelector');
      selects = quoteForm.DuplicatingFields.newElements('select');
      initSelectors();
    });
    var initSelectors = function initSelectors() {
      selectors.forEach(function (selector) {
        return selector.remove();
      });
      selects.forEach(function (select) {
        select.value = '';
        new SimpleSelector(select, {
          "class": 'formSelector'
        });
      });
    };
    locationSelect.addEventListener('change', function () {
      ajax({
        url: "".concat(window.location.origin).concat(window.location.pathname, "/getRepsForLocation?Title=").concat(locationSelect.value),
        method: 'GET',
        success: function success(r) {
          var data = JSON.parse(r).data;
          var current = {
            option: {
              el: null,
              value: null
            },
            data: null,
            list: []
          };
          for (var optionIndex = 0; optionIndex < repsSelect.SS.options.length; optionIndex++) {
            current.option.el = repsSelect.SS.options[optionIndex];
            current.option.value = current.option.el.getAttribute('data-value');
            current.option.el.style.display = 'none';
            if (current.option.value === '') continue;
            for (var name in data) {
              if (name === current.option.value) {
                current.option.el.style.display = 'block';
                current.list.push(name);
                break;
              }
            }
            current.option.el.removeAttribute('selected');
          }
          if (current.list.length === 0) {
            repsSelect.SS.select.classList.add('disabled');
            repsSelect.SS.placeholder.innerHTML = 'N/A';
          } else {
            repsSelect.SS.select.classList.remove('disabled');
            repsSelect.value = current.list[0];
            repsSelect.querySelector("[value=\"".concat(current.list[0], "\"]")).setAttribute('selected', 'true');
            repsSelect.SS.updateValue();
          }
        }
      });
    });
  }
});